// extracted by mini-css-extract-plugin
export default {"center":"OffersPage_center__IUU2w","fullCenter":"OffersPage_fullCenter__QVzp7","float":"OffersPage_float__S8sN3","uu":"OffersPage_uu__X6iPM"};